<div class="ms-modal-container">
  <!-- Executive MS Office Modal Header -->
  <div class="ms-modal-header">
    <div class="ms-modal-title-group">
      <i class="fas fa-calendar-alt ms-modal-icon"></i>
      <h5 class="ms-modal-title">Update Appointment Status</h5>
    </div>
    <button type="button" class="ms-modal-close-btn" (click)="activeModal.dismiss('Cross click')" title="Close">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <!-- Modal Body -->
  <div class="ms-modal-body" *ngIf="pdata1">
    <div *ngFor="let l of pdata1" class="ms-modal-card-wrap">

      <!-- Section 1: Patient Summary Grid -->
      <div class="ms-modal-info-grid">
        <div class="ms-info-col">
          <span class="ms-info-label"><i class="far fa-calendar-alt text-primary margin-right-4px"></i> Appointment</span>
          <span class="ms-info-val-date">{{l.AppointmentDate | date: 'dd-MMM-yyyy'}}</span>
          <span class="ms-row-time-badge margin-top-4px">{{l.AppointmentDate | date: 'hh:mm a'}}</span>
        </div>

        <div class="ms-info-col">
          <span class="ms-info-label"><i class="far fa-user text-primary margin-right-4px"></i> Patient Details</span>
          <span class="ms-info-val-name">{{l.PatientName}}</span>
          <span class="ms-info-sub">{{l.Gender}}, {{l.Age}} Years</span>
        </div>

        <div class="ms-info-col">
          <span class="ms-info-label"><i class="fas fa-address-book text-primary margin-right-4px"></i> Contact Information</span>
          <span class="ms-info-sub" *ngIf="l.Telephone1"><i class="fas fa-phone margin-right-4px"></i> {{l.Telephone1}}</span>
          <span class="ms-info-sub" *ngIf="l.Email"><i class="fas fa-envelope margin-right-4px"></i> {{l.Email}}</span>
          <span class="ms-info-sub" *ngIf="!l.Email"><i class="fas fa-envelope margin-right-4px"></i> ---</span>
        </div>
      </div>

      <!-- Section 2: Status Stepper Checkboxes -->
      <div class="ms-modal-stepper-box">
        <h6 class="ms-stepper-title">Appointment Workflow Status</h6>

        <div class="ms-row-status-stepper" *ngIf="!l.NoShowStatus">
          <div class="ms-status-check-item">
            <span>Check-In</span>
            <input type="checkbox" (change)="onSubmit(l,'CHECKIN', $event)" [(ngModel)]="l.CheckInStatus">
          </div>
          <div class="ms-status-check-item">
            <span>Enc-Start</span>
            <input type="checkbox" name="1.EncounterStartStatus" (change)="onSubmit(l,'ENCSTART', $event)" [(ngModel)]="l.EncounterStartStatus">
          </div>
          <div class="ms-status-check-item">
            <span>Enc-end</span>
            <input type="checkbox" name="1.EncounterEndStatus" (change)="onSubmit(l,'ENCEND', $event)" [(ngModel)]="l.EncounterEndStatus">
          </div>
          <div class="ms-status-check-item">
            <span>Check-out</span>
            <input type="checkbox" name="1.CheckOutStatus" (change)="onSubmit(l,'CHECKOUT', $event)" [(ngModel)]="l.CheckOutStatus">
          </div>
        </div>

        <div class="ms-row-status-stepper" *ngIf="!l.CheckInStatus && l.NoShowStatus">
          <div class="ms-status-check-item">
            <span>No Show</span>
            <input type="checkbox" name="1.NoShowStatus" (change)="onSubmit(l,'NOSHOW', $event)" [(ngModel)]="l.NoShowStatus">
          </div>
        </div>
      </div>

      <!-- Section 3: Visit Info & Action Buttons -->
      <div class="ms-modal-footer-actions">
        <div class="display-flex align-items-center gap-10px" *ngIf="l.BillNo || l.VisitType">
          <span class="ms-patient-code-tag" *ngIf="l.BillNo">{{l.BillNo}}</span>
          <span class="badge badge-success font-size-11px" *ngIf="l.VisitType">{{l.VisitType}}</span>
        </div>

        <div class="display-flex align-items-center gap-10px margin-left-auto">
          <button type="button" (click)="Profile(l)" class="ms-action-pill-btn" title="View Patient Profile"
                  *ngIf="l.AppointmentStatus=='CHECKIN' || l.AppointmentStatus=='CHECKOUT' || l.AppointmentStatus=='ENCSTART' || l.AppointmentStatus=='ENCEND'">
            <i class="fas fa-user text-primary"></i> Profile
          </button>

          <button type="button" (click)="Addbill(l)" class="ms-action-pill-btn btn-bill" title="Add Bill"
                  *ngIf="l.AppointmentStatus=='CHECKIN' || l.AppointmentStatus=='CHECKOUT' || l.AppointmentStatus=='ENCSTART' || l.AppointmentStatus=='ENCEND'">
            <i class="fas fa-plus"></i> Add Bill
          </button>

          <button type="button" (click)="cancel()" class="ms-action-pill-btn btn-cancel" title="Cancel Appointment"
                  *ngIf="l.AppointmentStatus=='Pending'">
            <i class="fas fa-times"></i> Cancel
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- Modal Footer -->
  <div class="ms-modal-footer">
    <button type="button" (click)="activeModal.close()" class="ms-btn-primary">
      Close
    </button>
  </div>
</div>
